import React, { useContext, useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { games } from "../data/games"; 
import { articles } from "../data/articles"; 
import { blogs } from "../data/blogs";       
import { AuthContext } from "../context/AuthContext";
import GameGallery from "../components/GameGallery";
import DailymotionPlayer from "../components/DailymotionPlayer";

function GameDetail() {
  const { id } = useParams();
  const { user, setUser } = useContext(AuthContext);
  const [rating, setRating] = useState(0);
  const [hover, setHover] = useState(0);
  const [isFavorite, setIsFavorite] = useState(false);
  
  // États pour les commentaires
  const [reviewText, setReviewText] = useState("");
  const [reviewsList, setReviewsList] = useState([]);
  const [replyToId, setReplyToId] = useState(null); 
  const [replyText, setReplyText] = useState("");   

  const game = games.find((g) => g.id === Number(id));

  useEffect(() => {
    const savedVotes = JSON.parse(localStorage.getItem("gamePulseVotes") || "{}");
    if (savedVotes[id]) setRating(savedVotes[id]);

    const savedReviews = JSON.parse(localStorage.getItem(`reviews_${id}`) || "[]");
    setReviewsList(savedReviews);

    if (user?.favorites) {
      setIsFavorite(user.favorites.some(fav => fav.id === Number(id)));
    }
  }, [user, id]);

  // 1. FONCTION : PUBLIER UN COMMENTAIRE
  const handleReviewSubmit = () => {
    if (reviewText.trim() === "") return;
    const newReview = {
      id: Date.now(), // ID unique pour pouvoir supprimer
      user: user?.name || "Joueur",
      text: reviewText,
      date: new Date().toLocaleDateString(),
      replies: []
    };
    const updated = [newReview, ...reviewsList];
    setReviewsList(updated);
    localStorage.setItem(`reviews_${id}`, JSON.stringify(updated));
    setReviewText("");
  };

  // 2. FONCTION : SUPPRIMER
  const handleDeleteReview = (reviewId) => {
    const updated = reviewsList.filter(rev => rev.id !== reviewId);
    setReviewsList(updated);
    localStorage.setItem(`reviews_${id}`, JSON.stringify(updated));
  };

  // 3. FONCTION : RÉPONDRE
  const handleReplySubmit = (reviewId) => {
    if (replyText.trim() === "") return;
    const updated = reviewsList.map(rev => {
      if (rev.id === reviewId) {
        const newReply = {
          user: user?.name || "Joueur",
          text: replyText,
          date: new Date().toLocaleDateString()
        };
        return { ...rev, replies: [...(rev.replies || []), newReply] };
      }
      return rev;
    });
    setReviewsList(updated);
    localStorage.setItem(`reviews_${id}`, JSON.stringify(updated));
    setReplyText("");
    setReplyToId(null);
  };

  const handleVote = (star) => {
    setRating(star);
    const allVotes = JSON.parse(localStorage.getItem("gamePulseVotes") || "{}");
    allVotes[id] = star; 
    localStorage.setItem("gamePulseVotes", JSON.stringify(allVotes));
  };

  const toggleFavorite = () => {
    if (!user) return alert("⚠️ Connecte-toi !");
    let updatedFavorites = user.favorites ? [...user.favorites] : [];
    isFavorite ? updatedFavorites = updatedFavorites.filter(fav => fav.id !== game.id) : updatedFavorites.push({ id: game.id, title: game.title, image: game.images?.[0] });
    const updatedUser = { ...user, favorites: updatedFavorites };
    setUser(updatedUser);
    localStorage.setItem("user", JSON.stringify(updatedUser));
    setIsFavorite(!isFavorite);
  };

  if (!game) return <div style={{color: "white", padding: "150px", textAlign: "center"}}><h2>Jeu introuvable...</h2></div>;

  return (
    <div style={{ color: "white", backgroundColor: "#0b0b13", minHeight: "100vh" }}>
      <div style={{ height: "60vh", backgroundImage: `linear-gradient(to bottom, transparent, #0b0b13), url(${game.images?.[0] || "/images/default.png"})`, backgroundSize: 'cover', backgroundPosition: 'center', display: 'flex', alignItems: 'flex-end', padding: '60px' }}>
        <div style={styles.container}><h1 style={{ fontSize: '4rem', fontWeight: '900' }}>{game.title}</h1></div>
      </div>

      <div style={{ ...styles.container, ...styles.mainContent }}>
        <div style={styles.leftCol}>
          
          <section style={styles.card}>
            <h3 style={{ color: '#00ffcc' }}>Votre note :</h3>
            {[1, 2, 3, 4, 5].map((star) => (
              <button key={star} style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: '2.5rem', color: star <= (hover || rating) ? "#ffc107" : "#333" }}
                onClick={() => handleVote(star)} onMouseEnter={() => setHover(star)} onMouseLeave={() => setHover(0)}> ★ </button>
            ))}
          </section>

          <section style={{ marginBottom: '50px' }}>
            <h2 style={{ color: '#ec008c' }}>À propos</h2>
            <p style={{ whiteSpace: 'pre-line', opacity: 0.8 }}>{game.longDescription || game.description}</p>
          </section>

          <section style={{ marginBottom: '50px' }}><h2 style={{ marginBottom: '25px' }}>Galerie</h2><GameGallery images={game.images} /></section>

          {game.video && (
            <section style={{ marginBottom: '50px' }}>
              <h2 style={{ marginBottom: '20px' }}>Trailer Officiel</h2>
              {game.isDailymotion ? <DailymotionPlayer videoId={game.video} /> : (
                <div style={styles.videoWrapper}>
                  <iframe style={styles.iframe} src={`https://www.youtube.com/embed/${game.video}`} allowFullScreen></iframe>
                </div>
              )}
            </section>
          )}
            {/* ✅ INFOS SUPPLÉMENTAIRES (Ce qui manquait) */}
          <section style={{ background: '#1a1b26', padding: '30px', borderRadius: '20px', marginBottom: '50px' }}>
            <h2 style={{ color: '#00ffcc', marginBottom: '25px', borderBottom: '1px solid #333', paddingBottom: '10px' }}>Informations supplémentaires</h2>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '30px' }}>
              <div>
                <span style={styles.infoLabel}>📦 Publié par</span>
                <p style={styles.infoValue}>{game.developer?.name || "Non spécifié"}</p>
                <span style={styles.infoLabel}>📏 Taille</span>
                <p style={styles.infoValue}>{game.requirements?.storage || "TBA"}</p>
              </div>
              <div>
                <span style={styles.infoLabel}>📅 Date de sortie</span>
                <p style={styles.infoValue}>{game.releaseDate}</p>
                <span style={styles.infoLabel}>🎮 Plateformes</span>
                <p style={styles.infoValue}>{game.platformIcons?.join(', ').toUpperCase()}</p>
              </div>
              <div>
                <span style={styles.infoLabel}>📂 Genres</span>
                <p style={styles.infoValue}>{game.genre?.join(', ')}</p>
                <span style={styles.infoLabel}>🌐 Langues</span>
                <p style={styles.infoValue}>{game.languages?.join(', ')}</p>
              </div>
            </div>
          </section>


          {/* SECTION COMMUNAUTÉ RÉPARÉE */}
          <section style={styles.card}>
            <h2 style={{ color: '#00ffcc', marginBottom: '20px' }}>💬 Communauté</h2>
            {user ? (
              <div style={{ marginBottom: '30px' }}>
                <textarea value={reviewText} onChange={(e) => setReviewText(e.target.value)} placeholder="Partagez votre avis..." style={styles.textarea} />
                <button onClick={handleReviewSubmit} style={styles.primaryBtn}>Publier</button>
              </div>
            ) : <p style={{ textAlign: 'center', opacity: 0.6 }}>Connectez-vous pour participer.</p>}

            <div style={{ marginTop: '30px' }}>
              {reviewsList.map((rev) => (
                <div key={rev.id} style={styles.reviewBox}>
                  <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <strong style={{ color: '#00ffcc' }}>{rev.user}</strong>
                    <div style={{ display: 'flex', gap: '10px' }}>
                      <button onClick={() => setReplyToId(rev.id)} style={styles.ghostBtn}>Répondre</button>
                      <button onClick={() => handleDeleteReview(rev.id)} style={styles.deleteBtn}>Supprimer</button>
                    </div>
                  </div>
                  <p style={{ margin: '10px 0', opacity: 0.9 }}>{rev.text}</p>
                  
                  {/* RÉPONSES */}
                  {rev.replies?.map((reply, i) => (
                    <div key={i} style={styles.replyBox}>
                      <strong style={{ color: '#ec008c', fontSize: '0.8rem' }}>{reply.user}</strong>
                      <p style={{ fontSize: '0.9rem', margin: '5px 0' }}>{reply.text}</p>
                    </div>
                  ))}

                  {/* FORMULAIRE RÉPONSE */}
                  {replyToId === rev.id && (
                    <div style={{ marginTop: '10px', display: 'flex', gap: '10px' }}>
                      <input value={replyText} onChange={(e) => setReplyText(e.target.value)} placeholder="Votre réponse..." style={styles.input} />
                      <button onClick={() => handleReplySubmit(rev.id)} style={styles.smallBtn}>Envoyer</button>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </section>
        </div>

        <div style={styles.rightCol}>
          <div style={styles.stickySide}>
             <div style={{ textAlign: 'center', marginBottom: '20px' }}>
               <span style={{ fontSize: '2.5rem', fontWeight: 'bold' }}>{game.bestPrice}$</span>
             </div>
             <a href={game.buyLink} target="_blank" rel="noopener noreferrer"><button style={styles.buyBtn}>ACHETER</button></a>
             <button onClick={toggleFavorite} style={styles.favBtn}>{isFavorite ? "❤️ Favori" : "🤍 Ajouter"}</button>
          </div>
        </div>
      </div>
    </div>
  );
}

const styles = {
  container: { maxWidth: '1200px', margin: '0 auto', width: '100%' },
  mainContent: { display: 'flex', gap: '40px', padding: '40px 20px', flexWrap: 'wrap' },
  leftCol: { flex: '2', minWidth: '300px' },
  rightCol: { flex: '1', minWidth: '250px' },
  card: { background: '#1a1b26', padding: '30px', borderRadius: '20px', marginBottom: '50px' },
  textarea: { width: '100%', background: '#0b0b13', color: 'white', border: '1px solid #333', padding: '15px', borderRadius: '10px', minHeight: '80px', marginBottom: '10px' },
  input: { flex: 1, background: '#0b0b13', color: 'white', border: '1px solid #444', padding: '8px', borderRadius: '5px' },
  primaryBtn: { background: '#ec008c', color: 'white', border: 'none', padding: '10px 25px', borderRadius: '5px', cursor: 'pointer', fontWeight: 'bold' },
  smallBtn: { background: '#00ffcc', color: 'black', border: 'none', padding: '5px 15px', borderRadius: '5px', fontWeight: 'bold', cursor: 'pointer' },
  ghostBtn: { background: 'none', border: 'none', color: '#888', cursor: 'pointer', fontSize: '0.8rem' },
  deleteBtn: { background: 'none', border: 'none', color: '#ff4444', cursor: 'pointer', fontSize: '0.8rem' },
  reviewBox: { background: '#0b0b13', padding: '15px', borderRadius: '12px', marginBottom: '15px', border: '1px solid #333' },
  replyBox: { marginLeft: '30px', marginTop: '10px', padding: '10px', borderLeft: '2px solid #ec008c', background: '#1a1b26', borderRadius: '5px' },
  videoWrapper: { position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden', borderRadius: '20px' },
  iframe: { position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', border: 'none' },
  stickySide: { position: 'sticky', top: '100px', background: '#1a1b26', padding: '30px', borderRadius: '20px' },
  buyBtn: { width: '100%', padding: '18px', border: 'none', borderRadius: '10px', fontWeight: 'bold', color: 'white', cursor: 'pointer', background: '#ec008c' },
  favBtn: { marginTop: '20px', background: 'transparent', color: '#fff', border: '1px solid #333', width: '100%', padding: '12px', borderRadius: '8px', cursor: 'pointer' }
};

export default GameDetail;